import React, { useState, useEffect } from 'react';
import './PhoneInputField.scss';

// Format: xxx-xxx-xxxx
const maskPhone = (text: string) => {
  if (!text) {
    return text;
  }
  const p = text.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  if (!p?.[2]) {
    return p?.[1];
  }
  const p1 = `${p[1]}-`;
  const p2 = p[2];
  const p3 = p[3] ? `-${p[3]}` : '';
  return `${p1}${p2}${p3}`;
};

interface PhoneInputFieldProps {
  formData: string;
  onChange: (e: string | null) => void;
}

function PhoneInputField(props: PhoneInputFieldProps) {
  const [value, setValue] = useState<string | null>(props.formData);
  useEffect(() => {
    setValue(props.formData);
  }, [props.formData]);
  return (
    <div className="phone-input-field">
      <p className="phone-input-field-title">Phone</p>
      <input
        value={value || ''}
        onChange={e => {
          const res = maskPhone(e.target.value) || null;
          setValue(res);
          props.onChange(res);
        }}
      />
    </div>
  );
}

export default PhoneInputField;
